/* eslint-disable max-classes-per-file */
export interface RequestHotelSeoInterface {
  lang?: string;
  countrySlug: string;
  citySlug?: string;
  areaSlug?: string;
  limit?: number;
  page?: number;
}

export interface Breadcrumbs {
  countryName: string;
  countrySlug: string;
  cityName?: string;
  citySlug?: string;
  areaName?: string;
  areaSlug?: string;
}
export interface ResponseHotelSeoInterface {
  breadcrumbs: Breadcrumbs;
  hotels: Hotel[];
  allCity?: CityAndAreaSlug[];
  allArea?: CityAndAreaSlug[];
  total: number;
  status?: boolean;
  message?: string;
  latitude?: number;
  longitude?: number;
}
export interface CityAndAreaSlug {
  name: string;
  slug: string;
}

export interface Hotel {
  id: number;
  hotelName: string;
  hotelSlug: string;
  hotelStar: number;
  review: Review;
  countrySlug: string;
  countryUrl: string;
  citySlug: string;
  cityUrl: string;
  areaSlug: any;
  areaUrl: any;
  facilities: string[];
  isFreeWifi: number;
  isFreeParking: number;
  facilitiesDetail: FacilitiesDetail[];
  images: string[];
  limit: number;
  pagination: number;
  isFavourite: boolean;
}

export interface Review {
  rating: any;
  text_rating_detail: any;
  num_reviews: any;
}

export interface FacilitiesDetail {
  groupId: number;
  groupName: string;
  details: Detail[];
}

export interface Detail {
  id: number;
  name: string;
  image: string;
}

class BreadcrumbsClass {
  countryName: string;

  countrySlug: string;

  cityName: string | undefined;

  citySlug: string | undefined;

  areaName: string | undefined;

  areaSlug: string | undefined;

  constructor(response: any) {
    this.countryName = response.countryName || "";
    this.countrySlug = response.countrySlug || "";
    this.cityName = response.cityName || undefined;
    this.citySlug = response.citySlug || undefined;
    this.areaName = response.areaName || undefined;
    this.areaSlug = response.areaSlug || undefined;
  }
}

class CityAndAreaSlugClass {
  name: string;

  slug: string;

  constructor(response: any) {
    this.name = response.name || "";
    this.slug = response.slug || "";
  }
}

class ReviewClass {
  rating: any;

  text_rating_detail: any;

  num_reviews: any;

  constructor(response: any) {
    this.rating = response.rating || 0;
    this.text_rating_detail = response.text_rating_detail || "";
    this.num_reviews = response.num_reviews || 0;
  }
}

class DetailClass {
  id: number;

  name: string;

  image: string;

  constructor(response: any) {
    this.id = response.id || 0;
    this.name = response.name || "";
    this.image = response.image || "";
  }
}

class FacilitiesDetailClass {
  groupId: number;

  groupName: string;

  details: Detail[];

  constructor(response: any) {
    this.groupId = response.groupId || 0;
    this.groupName = response.groupName || "";
    this.details = (response.details || []).map(
      (detail: any) => new DetailClass(detail),
    );
  }
}

class HotelClass {
  id: number;

  hotelName: string;

  hotelSlug: string;

  hotelStar: number;

  review: Review;

  countrySlug: string;

  countryUrl: string;

  citySlug: string;

  cityUrl: string;

  areaSlug: any;

  areaUrl: any;

  facilities: string[];

  isFreeWifi: number;

  isFreeParking: number;

  facilitiesDetail: FacilitiesDetail[];

  images: string[];

  limit: number;

  pagination: number;

  isFavourite: boolean;

  constructor(response: any) {
    this.id = response.id || 0;
    this.hotelName = response.hotelName || "";
    this.hotelSlug = response.hotelSlug || "";
    this.hotelStar = response.hotelStar || 0;
    this.review = new ReviewClass(response.review || {});
    this.countrySlug = response.countrySlug || "";
    this.countryUrl = response.countryUrl || "";
    this.citySlug = response.citySlug || "";
    this.cityUrl = response.cityUrl || "";
    this.areaSlug = response.areaSlug || null;
    this.areaUrl = response.areaUrl || null;
    this.facilities = response.facilities || [];
    this.isFreeWifi = response.isFreeWifi || 0;
    this.isFreeParking = response.isFreeParking || 0;
    this.facilitiesDetail = (response.facilitiesDetail || []).map(
      (facility: any) => new FacilitiesDetailClass(facility),
    );
    this.images = response.images || [];
    this.limit = response.limit || 0;
    this.pagination = response.pagination || 0;
    this.isFavourite = response.isFavourite || false;
  }
}

export class ResponseHotelSeoClass {
  breadcrumbs: Breadcrumbs;

  hotels: Hotel[];

  allCity: CityAndAreaSlug[] | undefined;

  allArea: CityAndAreaSlug[] | undefined;

  total: number;

  status: boolean | undefined;

  message: string | undefined;

  latitude: number | undefined;

  longitude: number | undefined;

  constructor(response: any) {
    this.breadcrumbs = new BreadcrumbsClass(response.breadcrumbs || {});
    this.hotels = (response.hotels || []).map(
      (hotel: any) => new HotelClass(hotel),
    );
    this.allCity = (response.allCity || []).map(
      (city: any) => new CityAndAreaSlugClass(city),
    );
    this.allArea = (response.allArea || []).map(
      (area: any) => new CityAndAreaSlugClass(area),
    );
    this.total = response.total || 0;
    this.status = response.status || undefined;
    this.message = response.message || undefined;
    this.latitude = response.latitude || undefined;
    this.longitude = response.longitude || undefined;
  }
}
